import { render } from "./invitationMediate.vue?vue&type=template&id=6d6a9810&scoped=true"
import script from "./invitationMediate.vue?vue&type=script&lang=js"
export * from "./invitationMediate.vue?vue&type=script&lang=js"

import "./invitationMediate.vue?vue&type=style&index=0&id=6d6a9810&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6a9810"]])

export default __exports__